<template>
    <div class="interment-file-wrapper" @click.prevent="openFile">
        <div class="document-icon">
            <img loading="lazy" src="https://demo-us.chronicle.rip/assets/images/document_icon.svg" alt="">
        </div>
        <div class="document-name text-truncate">
            <p class="name">{{ filename }}</p>
        </div>
    </div>
</template>

<script>
    export default {
        mixins: [
        ],
        props: {
            value: {
                type: Object,
                default: () => {
                    return {};
                },
            },
            openTarget: {
                type: String,
                default: '_blank'
            }
        },
        data() {
            return {

            }
        },
        computed: {
            filename() {
                return this.value?.filename;
            },
            url() {
                return this.value?.url;
            },
        },
        methods: {
            openFile() {
                if(this.url) {
                    window.open(this.url, this.openTarget).focus();
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.interment-file-wrapper {
    margin-bottom: 8px;
    display: flex;
    width: 100%;
    background: #f5f5f5;
    border-radius: 4px;
    cursor: pointer;

    .document-icon {
        background: #dfdfe1;
        border-radius: 4px 0 0 4px;
        height: auto;
        width: 64px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            padding: 18px;
        }
    }

    .document-name {
        display: flex;
        margin: 16px 40px 0 10px;
        word-break: break-word;
        align-items: center;

        p {
            font-family: var(--city-medium-font-family);
            font-size: 14px;
            line-height: 16px;
            font-weight: 500;
            color: #181429;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
}
</style>